import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from "react-moment";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Spinner, Form } from "react-bootstrap";
import exportValue from "../../apiconfig";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import Swal from "sweetalert2";

const Lead_form = () => {
  const baseApi = exportValue?.API_BASE;

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3500,
  });

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [slotsData, setSlotsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showLeadModal, setShowLeadModal] = useState(false);
  const [leadDetail, setLeadDetail] = useState(null);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({ date: "", time: "" });

  const [form, setForm] = useState({ name: "", email: "", mobile: "" });
  const handleForm = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const [selectedDate, setSelectedDate] = useState(""); // For horizontal date tabs

  useEffect(() => {
    const today = new Date();
    const after10 = new Date();
    after10.setDate(after10.getDate() + 10);

    const t1 = today.toISOString().slice(0, 10);
    const t2 = after10.toISOString().slice(0, 10);

    setFromDate(t1);
    setToDate(t2);

    fetchSlots(t1, t2);
  }, []);

  const fetchSlots = async (from, to) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${exportValue.host}/lead_jetpost/lead/slots_admin?from_date=${from}&to_date=${to}`
      );

      setSlotsData(res.data.dates || []);
      if (res.data.dates?.length) setSelectedDate(res.data.dates[0].date); // select first date by default
    } catch (err) {
      console.log(err);
      Toast.fire({ icon: "error", title: "Failed to fetch slots" });
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = () => fetchSlots(fromDate, toDate);

  const openLeadDetail = (slot) => {
    setLeadDetail(slot.bookedBy);
    setShowLeadModal(true);
  };

  const openCreate = (slot) => {
    setSelectedSlot(slot);
    setShowCreateModal(true);
  };

  const createLead = async () => {
    if (!form.mobile || !selectedSlot.date)
      return Toast.fire({ icon: "error", title: "Mobile & Slot required" });

    try {
      await axios.post(`${exportValue.host}/lead_jetpost/lead/create_lead`, {
        ...form,
        slotDate: selectedSlot.date,
        slotTime: selectedSlot.time,
        bookedby: "admin",
      });

      Toast.fire({ icon: "success", title: "Lead created!" });
      setShowCreateModal(false);
      setForm({ name: "", email: "", mobile: "" });

      fetchSlots(fromDate, toDate);
    } catch (err) {
      Toast.fire({ icon: "error", title: err.response?.data?.message || "Error" });
    }
  };

  const deleteLead = async (lead) => {
   
    try {
      await axios.post(`${exportValue.host}/lead_jetpost/lead/delete_lead`, {
        lead_id: lead.leadId,
        });

      Toast.fire({ icon: "success", title: "Slot is Available Now!" });
      setShowLeadModal(false);
    
      fetchSlots(fromDate, toDate);
    } catch (err) {
      Toast.fire({ icon: "error", title: err.response?.data?.message || "Error" });
    }
  };

  const currentSlots =
    slotsData.find((d) => d.date === selectedDate)?.slots || [];
    console.log("currentSlots == " , currentSlots)

  return (
    <div>
      <Left_panel />
      <section className="home-section">
        <Sub_header />

        <Container fluid className="p-3">
          <div className="card p-3 shadow">
            <h4 className="mb-3">Lead Slot Manager</h4>

            {/* FILTERS */}
            <Row className="mb-3">
              <Col md={3}>
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Col>
              <Col md={2} className="d-flex align-items-end">
                <Button onClick={applyFilter} variant="primary">
                  Apply Filter
                </Button>
              </Col>
            </Row>

            {/* HORIZONTAL DATE TABS */}
            <div className="mb-3 d-flex overflow-auto gap-2">
              {slotsData.map((d) => (
                <Button
                  key={d.date}
                  variant={selectedDate === d.date ? "danger" : "secondary"}
                  onClick={() => setSelectedDate(d.date)}
                >
                  <Moment format="D MMM">{d.date}</Moment>
                </Button>
              ))}
            </div>

            {/* SLOTS GRID */}
            {loading ? (
              <div className="text-center p-5">
                <Spinner />
              </div>
            ) : (
              <div className="d-flex flex-wrap gap-2">
                {currentSlots.map((s) => (
                  <div
                    key={s.time}
                    className="p-2 text-center rounded"
                    style={{
                      border: "1px solid",
                      background:
                        s.available
                          ? "#d4edda"                      // green for available
                          : s.bookedBy.bookedby === "admin"
                          ? "#cce5ff"                       // 🔵 light blue for admin
                          : "#f8d7da",                      // red for user-booked
                      borderColor:
                        s.available
                          ? "#28a745"
                          : s.bookedBy.bookedby === "admin"
                          ? "#007bff"                       // 🔵 blue border
                          : "#dc3545",
                      cursor: "pointer",
                      minWidth: 90,
                    }}
                    onClick={() =>
                      s.available
                        ? openCreate({ date: selectedDate, time: s.time })
                        : openLeadDetail(s)
                    }
                  >
                    <strong>{s.time}</strong>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Container>

        {/* LEAD DETAIL MODAL */}
        <Modal show={showLeadModal} onHide={() => setShowLeadModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Lead Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {leadDetail ? (
              <>
                <p><b>Name:</b> {leadDetail.name}</p>
                <p><b>Email:</b> {leadDetail.email}</p>
                <p><b>Mobile:</b> {leadDetail.mobile}</p>
              </>
            ) : (
              <p>No details found</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={()=>deleteLead(leadDetail)}>
              Free Slot
            </Button>
          </Modal.Footer>
        </Modal>

        {/* CREATE LEAD MODAL */}
        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Create Lead</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              <b>Selected Slot:</b> {selectedSlot.date} - {selectedSlot.time}
            </p>

            <Form.Group className="mb-2">
              <label>Name</label>
              <input
                className="form-control"
                name="name"
                value={form.name}
                onChange={handleForm}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <label>Email</label>
              <input
                className="form-control"
                name="email"
                value={form.email}
                onChange={handleForm}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <label>Mobile *</label>
              <input
                className="form-control"
                name="mobile"
                value={form.mobile}
                onChange={handleForm}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="primary" onClick={createLead}>
              Create Lead
            </Button>
          </Modal.Footer>
        </Modal>
      </section>
    </div>
  );
};

export default Lead_form;
